export default __webpack_public_path__ + "static/media/omkargavaderesume.cc3914d8.pdf";